<script setup>
import { ref, computed, defineProps, watch } from 'vue';

const props = defineProps({
  year: {
    type: Number,
    required: true
  },
  month: {
    type: Number,
    required: true
  }
});

// --- Mock Data --- (Replace with actual API calls later)
const files = ref([]);

const fetchFiles = () => {
  // Mock file data based on selections - Replace with API call
  const type = '图片'; // This component is only for images
  const year = props.year;
  const month = props.month;
  const count = 10; // Example: 10 images
  const extension = 'png';
  files.value = Array.from({ length: count }, (_, i) => ({
    id: `${type}-${year}-${month}-${i + 1}`,
    name: `${type}${i + 1}.${extension}`,
    url: `/mock/${type}${i + 1}.${extension}` // Placeholder URL
  }));
  currentPage.value = 1; // Reset pagination on data change
};

// --- Pagination (Basic Example) ---
const currentPage = ref(1);
const itemsPerPage = ref(10); // Items per page for images

const paginatedFiles = computed(() => {
  const start = (currentPage.value - 1) * itemsPerPage.value;
  const end = start + itemsPerPage.value;
  return files.value.slice(start, end);
});

const totalPages = computed(() => {
  return Math.ceil(files.value.length / itemsPerPage.value);
});

function changePage(page) {
  if (page >= 1 && page <= totalPages.value) {
    currentPage.value = page;
  }
}

// Fetch files when props change
watch(() => [props.year, props.month], fetchFiles, { immediate: true });

</script>

<template>
  <div class="image-list-container">
    <div v-if="paginatedFiles.length > 0" class="image-grid">
      <div v-for="file in paginatedFiles" :key="file.id" class="image-card">
        <div class="image-placeholder">图片</div>
        <span>{{ file.name }}</span>
      </div>
    </div>
    <div v-else class="no-files">当月无图片文件</div>

    <!-- Pagination -->
    <div class="pagination" v-if="totalPages > 1">
       <a-pagination
         :current="currentPage"
         :total="files.length"
         :page-size="itemsPerPage"
         show-total
         show-jumper
         @change="changePage"
       />
    </div>
  </div>
</template>

<style scoped>
.image-list-container {
  /* Add container specific styles if needed */
}

.no-files {
    text-align: center;
    color: var(--color-text-3);
    margin-top: 40px;
    font-size: 1.1em;
}

/* Image Grid */
.image-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(120px, 1fr)); /* Responsive grid */
  gap: 15px;
  margin-bottom: 20px; /* Add margin below grid */
}

.image-card {
  border: 1px solid var(--color-border-2);
  border-radius: 4px;
  padding: 10px;
  text-align: center;
  background-color: var(--color-bg-1);
  color: var(--color-text-1);
}

.image-placeholder {
  height: 80px; /* Adjust as needed */
  background-color: var(--color-fill-2);
  border: 1px dashed var(--color-border-2);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 8px;
  border-radius: 4px;
  color: var(--color-text-3);
}

.image-card span {
  font-size: 0.9em;
  word-break: break-all; /* Prevent long names from overflowing */
}

/* Pagination */
.pagination {
  display: flex;
  justify-content: right;
  gap: 5px;
  margin-top: 20px; /* Add margin above pagination */
  padding-top: 15px;
  border-top: 1px solid var(--color-border-1);
}
</style>